import React from 'react';
import { Link } from 'react-router-dom';

function SavedScans() {
  return (
    <div className="authenticated-page">
      <div className="authenticated-page-content">
        <h1 className="authenticated-page-title">Saved Scans</h1>
        <p className="authenticated-page-body">
          This page will display a list of all saved scans with filtering, sorting, and comparison
          tools. Scan history and results will be managed here.
        </p>
        <nav className="authenticated-page-nav">
          <Link to="/dashboard">← Back to Dashboard</Link>
        </nav>
      </div>
    </div>
  );
}

export default SavedScans;
